// Hooks
//

// Classes
//


class RelatedContent {
  constructor(element) {
    this.element = element;
    
    this.init();
  }

  init() {
  }
}

export default RelatedContent;
